'use strict';

Object.defineProperty(exports, "__esModule", {
				value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    color: ', ';\n    font-family: ', ';\n    letter-spacing: ', ';\n    font-size: ', ';\n    line-height: ', ';\n    border: ', ';\n    border-radius: ', ';\n    float: left;\n    padding: 5px;\n    min-height: 100px;\n    outline: none;\n    resize: none;\n    padding-top: 10px;\n    padding-left: 10px;\n    padding-right: 10px;\n    padding-bottom: 10px;\n    ', '\n    margin-top: ', 'px;\n    margin-bottom: ', 'px;\n    margin-left: ', 'px;\n    margin-right: ', 'px;\n    width: calc(100% - 20px);\n\n    &::-webkit-scrollbar {\n        width: 5px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: ', ';\n        border-radius: ', ';\n\n        &:hover {\n            background: ', ';\n        }\n    }\n'], ['\n    color: ', ';\n    font-family: ', ';\n    letter-spacing: ', ';\n    font-size: ', ';\n    line-height: ', ';\n    border: ', ';\n    border-radius: ', ';\n    float: left;\n    padding: 5px;\n    min-height: 100px;\n    outline: none;\n    resize: none;\n    padding-top: 10px;\n    padding-left: 10px;\n    padding-right: 10px;\n    padding-bottom: 10px;\n    ', '\n    margin-top: ', 'px;\n    margin-bottom: ', 'px;\n    margin-left: ', 'px;\n    margin-right: ', 'px;\n    width: calc(100% - 20px);\n\n    &::-webkit-scrollbar {\n        width: 5px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: ', ';\n        border-radius: ', ';\n\n        &:hover {\n            background: ', ';\n        }\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../constants/colors');

var _radius = require('../../constants/radius');

var _getSize = require('../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _text = require('../../constants/text');

var _errorLabel = require('../errorLabel');

var _errorLabel2 = _interopRequireDefault(_errorLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Text = _styledComponents2.default.textarea(_templateObject, function (_ref) {
				var disabled = _ref.disabled,
				    hasError = _ref.hasError;

				if (disabled) return _colors.Colors.StrokeVeryDark;
				if (hasError) return _colors.Colors.Error;
				return _colors.Colors.PrimaryText;
}, _text.TextSizes.ParagraphFontFamily, _text.TextSizes.ParagraphLetterSpacing, _text.TextSizes.P2FontSize, _text.TextSizes.P2LineHeight, function (_ref2) {
				var hasError = _ref2.hasError;
				return hasError ? '1px solid ' + _colors.Colors.Error : '1px solid ' + _colors.Colors.StrokeDark;
}, _radius.Radius.small, function (_ref3) {
				var readOnly = _ref3.readOnly;
				return readOnly === false ? 'background-color: ' + _colors.Colors.cello5 + ';' : 'border: none;';
}, function (_ref4) {
				var top = _ref4.top;
				return (0, _getSize2.default)(top);
}, function (_ref5) {
				var bottom = _ref5.bottom;
				return (0, _getSize2.default)(bottom);
}, function (_ref6) {
				var left = _ref6.left;
				return (0, _getSize2.default)(left);
}, function (_ref7) {
				var right = _ref7.right;
				return (0, _getSize2.default)(right);
}, _colors.Colors.cello, _radius.Radius.large, _colors.Colors.cello45);

var FormTextArea = function (_React$Component) {
				_inherits(FormTextArea, _React$Component);

				function FormTextArea() {
								_classCallCheck(this, FormTextArea);

								return _possibleConstructorReturn(this, (FormTextArea.__proto__ || Object.getPrototypeOf(FormTextArea)).apply(this, arguments));
				}

				_createClass(FormTextArea, [{
								key: 'render',
								value: function render() {
												var _this2 = this;

												var rows = this.props.rows || '3';
												var cols = this.props.cols || '20';

												return _react2.default.createElement(
																_react2.default.Fragment,
																null,
																_react2.default.createElement(Text, {
																				className: this.props.className,
																				rows: rows,
																				cols: cols,
																				top: this.props.top,
																				bottom: this.props.bottom,
																				left: this.props.left,
																				right: this.props.right,
																				readOnly: this.props.readOnly,
																				onChange: function onChange(e) {
																								return _this2.props.changeEvent(e.target.value);
																				},
																				value: this.props.text,
																				placeholder: this.props.placeholder,
																				hasError: this.props.error,
																				disabled: this.props.disabled
																}),
																this.props.error && this.props.errorLabel && _react2.default.createElement(_errorLabel2.default, { text: this.props.errorLabel,
																				disabled: this.props.disabled
																}),
																this.props.serverErrors && this.props.serverErrors.length !== 0 && this.props.serverErrors.map(function (err) {
																				return _react2.default.createElement(_errorLabel2.default, { error: true,
																								listItem: true,
																								textAlign: 'left',
																								text: err.message,
																								disabled: _this2.props.disabled
																				});
																}),
																this.props.serverWarnings && this.props.serverWarnings.length !== 0 && this.props.serverWarnings.map(function (war) {
																				return _react2.default.createElement(_errorLabel2.default, { warning: true,
																								listItem: true,
																								textAlign: 'left',
																								text: war.message,
																								disabled: _this2.props.disabled
																				});
																})
												);
								}
				}]);

				return FormTextArea;
}(_react2.default.Component);

exports.default = FormTextArea;